import { j as t } from "./atoms-v218.js";
import { Picture as s } from "./atoms-v233.js";
import { MAX_GRID_SLIDES as l, VARIANT_1_ASPECT_RATIOS as j } from "./atoms-v21045.js";
import { Variant1SlidesGrid as b, Slide as p, SlideButton as u, Variant1SlideGroup as m, RelativeWrapper as A, ViewAllButton as R } from "./atoms-v2819.js";
const C = ({
  handleOnView: r,
  i18n: o,
  slides: c
}) => {
  const x = c && (c == null ? void 0 : c.length) > 0 ? c.slice(0, l) : [];
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsxs(b, { children: [
    /* @__PURE__ */ t.jsxs(p, { children: [
      /* @__PURE__ */ t.jsx(s, { aspectRatio: j[0], ...x[0] }),
      r && /* @__PURE__ */ t.jsx(
        u,
        {
          "aria-label": o == null ? void 0 : o.slideButtonAriaLabel,
          onClick: () => {
            var a;
            return r == null ? void 0 : r((a = x[0]) == null ? void 0 : a.id);
          },
          type: "button"
        }
      )
    ] }),
    /* @__PURE__ */ t.jsxs(p, { children: [
      /* @__PURE__ */ t.jsx(s, { aspectRatio: j[1], ...x[1] }),
      r && /* @__PURE__ */ t.jsx(
        u,
        {
          "aria-label": o == null ? void 0 : o.slideButtonAriaLabel,
          onClick: () => {
            var a;
            return r == null ? void 0 : r((a = x[1]) == null ? void 0 : a.id);
          },
          type: "button"
        }
      )
    ] }),
    /* @__PURE__ */ t.jsxs(m, { children: [
      /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsxs(p, { children: [
        /* @__PURE__ */ t.jsx(s, { aspectRatio: j[2], ...x[2] }),
        r && /* @__PURE__ */ t.jsx(
          u,
          {
            "aria-label": o == null ? void 0 : o.slideButtonAriaLabel,
            onClick: () => {
              var a;
              return r == null ? void 0 : r((a = x[2]) == null ? void 0 : a.id);
            },
            type: "button"
          }
        )
      ] }) }),
      /* @__PURE__ */ t.jsxs(A, { children: [
        /* @__PURE__ */ t.jsxs(p, { children: [
          /* @__PURE__ */ t.jsx(s, { aspectRatio: j[3], ...x[3] }),
          r && /* @__PURE__ */ t.jsx(
            u,
            {
              "aria-label": o == null ? void 0 : o.slideButtonAriaLabel,
              onClick: () => {
                var a;
                return r == null ? void 0 : r((a = x[3]) == null ? void 0 : a.id);
              },
              type: "button"
            }
          )
        ] }),
        r && c && (c == null ? void 0 : c.length) > l ? /* @__PURE__ */ t.jsx(
          R,
          {
            ariaLabel: o == null ? void 0 : o.viewAllButtonAriaLabel,
            colorTheme: "dark",
            onClick: () => r(),
            shape: "square",
            size: "small",
            variant: "primary",
            children: o == null ? void 0 : o.viewAllButtonText
          }
        ) : null
      ] })
    ] })
  ] }) });
};
export {
  C as Variant1
};
